var map = {
	"./decidim/categories/event-category-conference.svg": 93032,
	"./decidim/categories/event-category-other.svg": 57740,
	"./decidim/categories/event-category-special_event.svg": 37150,
	"./decidim/categories/event-category-study_visit.svg": 59485,
	"./decidim/categories/event-category-training.svg": 52932,
	"./decidim/categories/event-category-workshop.svg": 52205,
	"./decidim/categories/offer-category-animals.svg": 2783,
	"./decidim/categories/offer-category-civil-activities.svg": 30293,
	"./decidim/categories/offer-category-culture.svg": 5946,
	"./decidim/categories/offer-category-ecology.svg": 25944,
	"./decidim/categories/offer-category-education.svg": 67478,
	"./decidim/categories/offer-category-health.svg": 21814,
	"./decidim/categories/offer-category-new-technologies.svg": 16293,
	"./decidim/categories/offer-category-other.svg": 82442,
	"./decidim/categories/offer-category-social-assistance.svg": 19518,
	"./decidim/categories/offer-category-sport.svg": 38397,
	"./decidim/categories/type-knowledge-base.svg": 31763,
	"./decidim/city_hall_logo.svg": 84512,
	"./decidim/city_hall_vertical_logo_en.svg": 54431,
	"./decidim/city_hall_vertical_logo_pl.svg": 38486,
	"./decidim/city_hall_vertical_white_logo.svg": 5133,
	"./decidim/ow-icon.symbol.svg": 81739,
	"./decidim/register_organization.svg": 53192,
	"./decidim/register_volounteer.svg": 94442,
	"./decidim/social_media/facebook.png": 9735,
	"./decidim/social_media/instagram.png": 1375,
	"./favicon-32x32.png": 44537,
	"./og_image.png": 81270,
	"./ow_blue.png": 32157,
	"./ow_white.png": 77486
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;